import { AuthResponse } from "@api/*";

export interface AuthUserStore extends AuthResponse {
  isAuthenticated: boolean;
  isLoading: boolean;
  loginType: 'public' | null;
  tokenExpiration: Date | null;
  error: string | null;
}

export const initialAuthUserStore: AuthUserStore = {
  id: '',
  userName: undefined,
  email: undefined,
  expiration: new Date(),
  isAuthenticated: false,
  isLoading: false,
  loginType: null,
  tokenExpiration: null,
  error: null,
};
